// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard_dashboard_26-EI"};